import { render, staticRenderFns } from "./FileUploadGrid.vue?vue&type=template&id=5873e270&scoped=true&"
import script from "./FileUploadGrid.vue?vue&type=script&lang=js&"
export * from "./FileUploadGrid.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadGrid.vue?vue&type=style&index=0&id=5873e270&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5873e270",
  null
  
)

export default component.exports